export const isEllipsisActive = (textContainer: HTMLInputElement | HTMLDivElement) =>
    textContainer.offsetHeight < textContainer.scrollHeight || textContainer.offsetWidth < textContainer.scrollWidth;
